import { createAsyncThunk } from "@reduxjs/toolkit";

import * as userAPI from "../../../api/user";
import { IUser } from "../../../models/user";

/**
 * Load the current authenticated user.
 *
 * Fetches user data from the API and updates the Redux store.
 * Used during CSR toolbar initialization and session management.
 *
 * @returns {Promise<IUser>} The loaded user data
 *
 * @example
 * // In a component
 * const dispatch = useAppDispatch();
 * const result = await dispatch(loadCurrentUser());
 *
 * // In CSR initialization
 * const user = await store.dispatch(loadCurrentUser()).unwrap();
 *
 * @sideEffects
 * - Updates common.user state via extraReducers
 * - Triggers chat connector user data update (via setUser reducer)
 */
export const loadCurrentUser = createAsyncThunk<IUser, void>(
    "common/loadCurrentUser",
    async () => {
        return await userAPI.load();
    },
);
